import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

@inject('store')
@observer
class Left extends Component {
    render() {
        const { data } = this.props.store.general;
        const ADR = Object.entries(data.ADR || {}).map(x => x[1]);
        const totalNum = ADR.reduce((a, b) => (a + Number(b)), 0).toFixed(0);
        const monthNum = ADR.reduce((a, b) => a <= Number(b) ? Number(b) : a, 0).toFixed(0);

        return (
            <div className="content">
                <div className="title">平均房价 ADR</div>
                <div className="text"></div>
                <div id="BI_title_right" style={{ height: 160, width: "100%" }}> </div>
                <div className="foot">最高平均房价 Highest：{monthNum}</div>
            </div>
        );
    }
}

export default Left;


// WEBPACK FOOTER //
// ./src/components/BI/home/title/Right.js